import { AxiosResponse } from "axios";
import API from "../api";
import { ItemTypes } from "../models/item.types";

const ROUTE_NAME = "item/types";

const ItemTypesService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<ItemTypes[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(packaging: ItemTypes): Promise<AxiosResponse<ItemTypes>> {
    return await API.post(`/${ROUTE_NAME}`, packaging);
  },
  async update(id: number, packaging: ItemTypes): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, packaging);
  },
};

export default ItemTypesService;
